const MaterialTableLocalization = {
    "body": {
      "emptyDataSourceMessage": "No hay datos por mostrar",
      "addTooltip": "Añadir",
      "deleteTooltip": "Eliminar",
      "editTooltip": "Editar",
      "filterRow": {
        "filterTooltip": "Filtrar"
      },
      "editRow": {
        "deleteText": "¿Segura(o) que quiere eliminar?",
        "cancelTooltip": "Cancelar",
        "saveTooltip": "Guardar"
      }
    },
    "grouping": {
        "placeholder": "Arrastre un encabezado aquí para agrupar",
        "groupedBy": "Agrupado por"
    },
    "header": {
        "actions": "Acciones"
    },
    "pagination": {
        "firstAriaLabel": "Primera página",
        "firstTooltip": "Primera página",
        "labelDisplayedRows": "{from}-{to} de {count}",
        "labelRowsPerPage": "Registros por página:",
        "labelRows": "registros",
        "lastAriaLabel": "Ultima página",
        "lastTooltip": "Ultima página",
        "nextAriaLabel": "Pagina siguiente",
        "nextTooltip": "Pagina siguiente",
        "previousAriaLabel": "Pagina anterior",
        "previousTooltip": "Pagina anterior",
    },
    "toolbar": {
        "addRemoveColumns": "Agregar o eliminar columnas",
        "exportAriaLabel": "Exportar",
        "exportName": "Exportar a CSV",
        "exportTitle": "Exportar",
        "nRowsSelected": "{0} filas seleccionadas",
        "searchPlaceholder": "Buscar",
        "searchTooltip": "Buscar",
        "showColumnsAriaLabel": "Mostrar columnas",
        "showColumnsTitle": "Mostrar columnas"
    }
  }

  export default MaterialTableLocalization;